import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import AuthLayout, { Field } from "./AuthLayout";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) return toast.error("Password must be at least 6 characters");
    setLoading(true);
    try {
      await register(form);
      toast.success("Account created! Let's set up your business.");
      nav("/onboarding");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail) || "Registration failed");
    }
    setLoading(false);
  };

  return (
    <AuthLayout title="Create your free account" subtitle="Set up in two minutes — a card is required (Free is never charged)"
      footer={<>Already have an account? <Link to="/login" className="text-blue-accent font-semibold">Sign in</Link></>}>
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <Field label="Your name" required value={form.name} onChange={set("name")} data-testid="register-name" placeholder="Jane Smith" />
        <Field label="Email" type="email" required value={form.email} onChange={set("email")} data-testid="register-email" placeholder="you@business.com" />
        <Field label="Password" type="password" required value={form.password} onChange={set("password")} data-testid="register-password" placeholder="At least 6 characters" />
        <button disabled={loading} data-testid="register-submit" className="w-full px-5 py-3 rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-semibold transition-colors disabled:opacity-60">
          {loading ? "Creating…" : "Create account"}
        </button>
      </form>
      <p className="mt-4 text-xs text-slate-400">By creating an account you agree to our <Link to="/terms" className="underline">Terms</Link> and <Link to="/privacy" className="underline">Privacy Policy</Link>.</p>
    </AuthLayout>
  );
}
